import React from 'react'
import { useTranslation } from 'react-i18next'

const AgentDetails = ({ awbDetails }) => {
    const { t } = useTranslation(['labels'])
    const agentDetails = awbDetails.agentDetails || {}

    return (
        <div className='agent-details-section'>
                    <label className='section-heading awb-heading'>{t('CAPTURE_AWB.AGT_DTLS')}</label>
            {/* <div className='agent-details-table-wrapper'> */}
                <div className='agent-details-table'>
                    {/* Table Header Row */}
                    <div className='agent-details-table-row agent-details-table-header'>
                        <div>{t('COMMON.AGT_CODE')}</div>
                        <div>{t('CAPTURE_AWB.AGT_NAME')}</div>
                        <div>{t('CAPTURE_AWB.IATA_CODE')}</div>
                        <div>{t('CAPTURE_AWB.STAN')}</div>
                    </div>
                    {/* Table Data Row */}
                    <div className='agent-details-table-row agent-details-table-data'>
                        <div>{agentDetails.code || '-'}</div>
                        <div>{agentDetails.name || '-'}</div>
                        <div>{agentDetails.IATACode || '-'}</div>
                        <div>{agentDetails.stationCode || '-'}</div>
                    </div>
                </div>
            {/* </div> */}
        </div>
    )
}

export default AgentDetails

